import { FC } from "react";
import { IProps } from "./types";
import styles from "./styles.module.scss";

const MacroIconItem: FC<IProps> = ({
  title,
  icon,
  iconBackgroundCOlor,
  value,
  gap = 0,
}): JSX.Element => {
  return (
    <div style={{ gap: gap }} className={styles.wrapper}>
      <div style={{ height: "36px", display: "flex", alignItems: "center" }}>
        <span className={styles.value}>{value}</span>
      </div>

      <div className={styles.rowContainer}>
        <div
          style={{ backgroundColor: iconBackgroundCOlor }}
          className={styles.iconWrapper}
        >
          {icon}
        </div>

        <span className={styles.title}>{title}</span>
      </div>
    </div>
  );
};

export default MacroIconItem;
